var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30248 0.22347C1.00452 -0.07449 0.52143 -0.07449 0.22347 0.22347C-0.07449 0.52143 -0.07449 1.00452 0.22347 1.30248L2.21048 3.28949C2.59509 3.68335 2.59619 4.312 2.21379 4.7072L0.22347 6.69752C-0.07449 6.99548 -0.07449 7.47857 0.22347 7.77653C0.52143 8.07449 1.00452 8.07449 1.30248 7.77653L3.28071 5.7983C3.67508 5.40393 4.31278 5.40114 4.71071 5.78972L6.69752 7.77653C6.99548 8.07449 7.47857 8.07449 7.77653 7.77653C8.07449 7.47857 8.07449 6.99548 7.77653 6.69752L5.79845 4.71944C5.40117 4.32216 5.40122 3.67799 5.7985 3.28071L7.77653 1.30248C8.07449 1.00452 8.07449 0.52143 7.77653 0.22347C7.47857 -0.07449 6.99548 -0.07449 6.69752 0.22347L4.70728 2.21371C4.30913 2.59896 3.67403 2.59497 3.28079 2.20172L1.30248 0.22347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTransparent);
export default __webpack_public_path__ + "static/media/closeTransparent.9fc120e251a140893578c0a18b78bba9.svg";
export { ForwardRef as ReactComponent };